import { graphql } from 'gatsby';
import React from 'react';

import { RidesHubByDepartmentQuery } from '../../../../../graphql-types';
import { TPageProps } from '../../../../page-props';
import RideHubByDepartmentPage from '../../../../templates/rides-hub-by-department';

export default (props: TPageProps<RidesHubByDepartmentQuery>) => (
  <RideHubByDepartmentPage {...props} />
);

export const query = graphql`
  query RidesHubByDepartment($lang: String, $id: Int) {
    prismicRidesHub(lang: { eq: $lang }) {
      _previewable
      lang
      data {
        ...RidesHubByThemeData
      }
    }
    allRide(filter: { data: { departmentsIds: { in: [$id] } } }) {
      nodes {
        data {
          ...RidesHubByThemeRideData
        }
      }
    }
    department(data: { id: { eq: $id } }) {
      data {
        name
      }
    }
  }
`;
